import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getStaffPlayingPeek } from '../../api/playing';

/** Compact staff peek: live game / accuracy + profile/desk links. */
export default function PlayingPeekCell({ userId }) {
  const { t } = useTranslation();
  const [peek, setPeek] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (userId == null) return undefined;
    let cancelled = false;
    getStaffPlayingPeek(userId)
      .then((d) => {
        if (!cancelled) {
          setPeek(d);
          setErr('');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPeek(null);
          setErr('!');
        }
      });
    return () => { cancelled = true; };
  }, [userId]);

  const live = peek?.liveGame;
  const acc = peek?.profile?.recentAccuracyPct;

  return (
    <div className="flex flex-col gap-1 text-xs text-slate-600 min-w-[9rem]">
      {err && <span className="text-amber-700" title={t('playing.loadFailed')}>{err}</span>}
      {!err && !peek && <span className="text-slate-400">…</span>}
      {live?.id && (
        <Link to={`/playing/spectate/${live.id}`} className="font-semibold text-emerald-700 hover:underline">
          {t('playing.liveNowPeek', { defaultValue: 'Live now' })}
        </Link>
      )}
      {acc != null && (
        <span className="tabular-nums">
          {t('playing.accuracyChip', { defaultValue: '{{pct}}% accuracy', pct: acc })}
        </span>
      )}
      <div className="flex flex-wrap gap-2 mt-0.5">
        <Link
          to={`/playing/players/${userId}`}
          className="font-semibold text-slate-700 hover:underline"
        >
          {t('playing.profile', { defaultValue: 'Profile' })}
        </Link>
        <Link
          to={`/playing/coach-board?studentId=${userId}`}
          className="font-semibold text-violet-700 hover:underline"
        >
          {t('playing.coachDesk', { defaultValue: 'Desk' })}
        </Link>
      </div>
    </div>
  );
}
